<template>
  <div class="col-md-12 default">
    <sido-code />
  </div>
</template>

<script>
import sidoCode from "./SidoCode.vue";

export default {
  components: {
    sidoCode
  },
  props: [],
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },

  methods: {
   
  },
};
</script>
